export default {
  inheritAttrs: false,
  props: {
    index: { type: [String, Number], default: '' },
    data: { default: () => [] }, option: { type: Object, default: () => ({}) },
    width: [Number, String], height: [Number, String], disabled: Boolean,
    navigation: { type: Object, default: () => ({ type: 'none' }) }
  }
}
